import { useAppDispatch } from "../../store/hooks/StoreHooks";
import { GetDocumentProjectsPayload } from "../../store/model/documents/documents";

const useDocumentFacade = () => {
    const dispatch = useAppDispatch();

    const loadMyAcknowledgeProjects = (payload: GetDocumentProjectsPayload) => {
        return dispatch({ type: "documents/getmyAcknowledgeProjects", payload });
    };

    const loadOtherAcknowledgeProjects = (payload: GetDocumentProjectsPayload) => {
        return dispatch({ type: "documents/getOtherAcknowledgeProjects", payload });
    };

    const loadMyArchivedProjects = (payload: GetDocumentProjectsPayload) => {
        return dispatch({ type: "documents/getmyArchivedProjects", payload });
    };

    const loadOtherArchivedProjects = (payload: GetDocumentProjectsPayload) => {
        return dispatch({ type: "documents/getOtherArchivedProjects", payload });
    };

    return {
        loadMyAcknowledgeProjects,
        loadMyArchivedProjects,
        loadOtherAcknowledgeProjects,
        loadOtherArchivedProjects
    };
};

export default useDocumentFacade;